import { Component, OnInit } from '@angular/core';
import { NtCompany } from '../../models/nt-company';
import { AuthService } from '../../../../services/auth.service';
import { DataLoadingService } from '../../../../services/data-loading.service';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { CompanyService } from '../../../../services/company.service';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { FormBuilder } from '@angular/forms';
import { IGroupContainer } from '../../models/group-edit-config';
import { HelpCenterComponent } from '../help-center/help-center.component';
import { ModalEditorComponent } from '../modal-editor/modal-editor.component';
import { dialogDefaultFullScreen } from '../../models/dialogDefaults';

@Component({
  selector: 'app-primary-nav',
  templateUrl: './primary-nav.component.html',
  styleUrls: ['./primary-nav.component.scss'],
  animations: [
    // the fade-in/fade-out animation.
    trigger('simpleFadeAnimation', [

      // the "in" style determines the "resting" state of the element when it is visible.
      state('in', style({ opacity: 1 })),

      // fade in when created. this could also be written as transition('void => *')
      transition(':enter', [
        style({ opacity: 0 }),
        animate(200)
      ]),

      // fade out when destroyed. this could also be written as transition('void => *')
      transition(':leave',
        animate(200, style({ opacity: 0 })))
    ])
  ]
})
export class PrimaryNavComponent implements OnInit {
    isExpanded = false;
    isDisplayed = false;
    companySelected = false;
    isCompanyExternalDataEnabled = false;
    companyName = "";
    companyExternalDataProvider = "";
    userName = "";
    isUserCompanyAdmin = false;
    isUserSystemAdmin = false;
    companyId = '';
    region = '';
    financialYearEnd: any;
    nextProcessingDate: any;
    isRefreshingSummary = false;

    constructor(private auth: AuthService,
        private compSvc: CompanyService,
        public loadingSvc: DataLoadingService,
        private dlg: MatDialog,
        private fb: FormBuilder
    ) {
        
    }

    ngOnInit() {
        this.auth.isAuthenticated.subscribe(x => {
            this.isDisplayed = x;
            if (this.isDisplayed) {
                const user = this.auth.getCurrentUser;
                this.userName = user ? user.fullName : "";
                this.isUserSystemAdmin = user.systemAdmin;
            } else {
                this.userName = "";
            }
        });

        this.compSvc.SelectedCompany.subscribe(newComp => {
            this.updateCompanyDetails(newComp);
        });

        this.compSvc.CompanySummaryRefreshing.subscribe(isRefreshing => {
            this.isRefreshingSummary = isRefreshing;
        });

    }

    async updateCompanyDetails(newComp: NtCompany) {
        if (newComp === null || newComp === undefined || !this.auth.getCurrentUser) {
            this.companySelected = false;
            this.companyName = '';
            this.isCompanyExternalDataEnabled = false;
            this.isUserCompanyAdmin = false;
        } else {
            this.companySelected = true;
            this.companyName = newComp.companyName;
            this.companyId = newComp.safeId;
            this.companyExternalDataProvider = newComp.externalDataSource.dataSource;
            this.isCompanyExternalDataEnabled = newComp.isExternalDataEnabled;
            this.region = newComp.region;
            this.financialYearEnd = newComp.financialYearEnd;
            this.nextProcessingDate = newComp.nextProcessingDate;
            const match = newComp.users.find(x => {
                return x.userId === this.auth.getCurrentUser.id;
            });
            if (match) {
                if (match.role === 'Admin') {
                    this.isUserCompanyAdmin = true;
                } else {
                    this.isUserCompanyAdmin = false;
                }
            } else {
                this.isUserCompanyAdmin = false;
            }
        }
    }

    logout() {
        this.auth.logout(null);
        
    }

    refreshCompanySummary(){
        this.compSvc.refreshCompanySummaryData(true);
    }

    async openHelpCentre(){
        const form = this.fb.group({});
        const g: IGroupContainer = {
            title: 'Help Centre',
            description: '',
            actionText: 'close',
            dialogMode: true,
            collapseGroupNav: true,
            hideCancelButton: true,
            data: {},
            form: form,
            groups: [
                {
                    header: 'g1',
                    id: '1001',
                    sections: [
                        {
                            header: '',
                            description: '',
                            form: form,
                            allowEdit: false,
                            items: [],
                            component: HelpCenterComponent
                        }
                    ]
                }
            ],
            completeAction: async(dRef: MatDialogRef<ModalEditorComponent>) => {
                dRef.close();
            }
        };

        this.dlg.open(ModalEditorComponent,
                            {
                                data: g,
                                ...dialogDefaultFullScreen
                            }
                        );
    }

}
